export default function (serial) {
    let value = serial.replace(/\D/g, '').substring(0, 6);
    let result = window.creditCardType(value);
    let brand = '';

    if (result.length == 1) {
        switch (result[0].type) {
            case 'american-express':
                brand = 'amex';
                break;

            case 'maestro':
                brand = 'aura';
                break;

            case 'diners-club':
                brand = 'diners';
                break;

            default:
                brand = result[0].type;
                break;
        }
    }

    return brand;
}



// WEBPACK FOOTER //
// ./scripts/util/brandCreditCard.js